import React from 'react';
import EcosystemTraction from './../shared/ecosystem/ecosystem';
import MarketAccess from '../shared/marketAccess/marketAccess';

const Test = () => (
  <div>
    <EcosystemTraction/>
    <MarketAccess/>
  </div>
);

export default Test;

